import * as React from 'react'
import classNames from 'classnames'
import { doNothing } from '../../../shared/lib/functional/function.no-deps'

interface ExecutionPageSubmitButton {
    disabled: boolean
    onSubmit: () => void
    label: string
}

export function ExecutionPageSubmitButton(props: ExecutionPageSubmitButton) {
    const { disabled, onSubmit, label } = props

    return (
        <div className="AppCore__flow__ExecutionPageSubmitButton__wrapper">
            <button
                data-testid="execution-page-submit-button"
                className={classNames('AppCore__flow__ExecutionPageSubmitButton', {
                    disabled,
                })}
                onClick={disabled ? doNothing : onSubmit}
            >
                {label}
            </button>
        </div>
    )
}
